import Common from './_develop/Common.es6';

const home = document.getElementById( 'home' );
if ( home ) {
	new Common();
}
